import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StockService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.stanthonyUrl}/stock`,{params:searchParams});
    }

    get(Id){
      return this.http.get(`${environment.stanthonyUrl}/stock/`+Id);
    }

    edit(Id,formData){
      return this.http.put(`${environment.stanthonyUrl}/stock/`+Id,formData);
    }

    create(formData){
      return this.http.post(`${environment.stanthonyUrl}/stock`,formData);
    }

    delete(Id){
      return this.http.delete(`${environment.stanthonyUrl}/stock/`+Id);
    }

}
